const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");
const Icon = require("app/shared/components/Icon/icon");
const Tooltip = require("app/shared/components/Tooltip/tooltip");
const CenteredCardContent = require("../Dashboard/centered-card-content");

const Reflux = require("reflux");
const WinRateStore = require("../../stores/win-rate-store");
const WinRateActions = require("../../actions/win-rate-actions");

const textFormatter = require("app/util/formatter/text");
const deltaCalculator = require("./util/delta-type");

const AnimatedValue = require("app/shared/components/AnimatedValue/animated-value");

const WinRateCountWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return WinRateStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(WinRateStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    WinRateActions.fetchData(
      this.props.period,
      this.props.comparison,
      this.props.users,
      this.props.funnel
    );
  },

  helpTooltipText: function() {
    const wonCount = this.state.data.won.count;
    const lostCount = this.state.data.lost.count;
    const percentage = textFormatter.formatValuePercentage(this.state.data.countPercentage);

    let text = "É uma taxa de conversão que representa a proporção de ganhos em relação ao total de finalizados (ganhos + perdidos) no período. Nesse caso, considerando a quantidade de negócios";
    text += "<br><br>Como no período houve <b>" + wonCount + " ganhos</b> e <b>" + lostCount + " perdidos</b>, a taxa de <b>" + percentage + "</b> ";
    text += "foi calculada usando a fórmula:<br>" + wonCount + " / (" + wonCount + " + " + lostCount + ")";

    return text;
  },

  tooltipText: function() {
    const comparisonStart = this.props.period.startDate.format("DD MMM, YYYY");
    const comparisonEnd = this.props.period.endDate.format("DD MMM, YYYY");
    const comparison = `${comparisonStart} - ${comparisonEnd}`;

    const wonCount = this.state.data.won.count;
    const lostCount = this.state.data.lost.count;
    const ratio = textFormatter.formatValuePercentage(this.state.data.countPercentage);

    return `Como em ${comparison} houve <b>${wonCount} ganhos</b> e <b>${lostCount} perdidos</b>, a taxa <b>${ratio}</b> foi calculada usando a fórmula:<br>${wonCount} / (${wonCount} + ${lostCount})`;
  },

  deltaTooltipText: function() {
    const comparisonStart = this.props.comparison.startDate.format("DD MMM, YYYY");
    const comparisonEnd = this.props.comparison.endDate.format("DD MMM, YYYY");
    const comparison = `${comparisonStart} - ${comparisonEnd}`;

    const noun = this.state.data.countPercentageDelta > 0 ? "Aumento" : "Redução";
    const value = textFormatter.formatValuePercentage(Math.abs(this.state.data.countPercentageDelta));

    return `${noun} de <b>${value}</b> comparado com a taxa em ${comparison}`;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Taxa ganhos vs perdidos</p>
        }
        className="mh-265"
      >
        <Tooltip
          html
          title={this.helpTooltipText()}
          container="#tooltip-container"
        >
          <Icon custom icon="help-circle" className="c-fontGray"/>
        </Tooltip>
        <CenteredCardContent>
          <Summary
            big
            value={<AnimatedValue value={this.state.data.countPercentage} formatter={textFormatter.formatValuePercentage} precision={1} />}
            tooltipText={this.tooltipText()}
            delta={<AnimatedValue value={this.state.data.countPercentageDelta} formatter={textFormatter.formatValuePercentage} precision={1} />}
            deltaTooltipText={this.deltaTooltipText()}
            deltaType={deltaCalculator.deltaType(this.state.data.countPercentageDelta)}
          />
        </CenteredCardContent>
      </CardWithLoader>
    )
  }
});

module.exports = WinRateCountWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/win-rate-count-widget.jsx